


export const appNabarRoutes = {
    settings: {
        security: "/settings/security",
        template: "/settings/templates",
        automation: "/settings/automation",
        paymentGateway: "/settigns/payment-gateway"
    }

}